// extracted by mini-css-extract-plugin
export var attachment = "_p2-a";
export var emailContainer = "_p2-4";
export var emailContentPaddedContainer = "_p2-b";
export var emailHeader = "_p2-6";
export var emailIframe = "_p2-3";
export var emailInfoIcon = "_p2-9";
export var emailShortenedSummary = "_p2-e";
export var infoDropdown = "_p2-0";
export var infoRowBoundedContent = "_p2-d";
export var internal = "_p2-5";
export var merchant = "_p2-8";
export var messageInputContainer = "_p2-h";
export var normal = "_p2-7";
export var replyCard = "_p2-f";
export var subtleButton = "_p2-1";
export var subtleButtonIconContainer = "_p2-2";
export var toggleViewRepliesButton = "_p2-c";
export var wrappingText = "_p2-g";